import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Annotate = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 2.5H12.5C13.0523 2.5 13.5 2.94772 13.5 3.5V12.5C13.5 13.0523 13.0523 13.5 12.5 13.5H3.5C2.94772 13.5 2.5 13.0523 2.5 12.5V3.5C2.5 2.94772 2.94772 2.5 3.5 2.5ZM1.5 3.5C1.5 2.39543 2.39543 1.5 3.5 1.5H12.5C13.6046 1.5 14.5 2.39543 14.5 3.5V12.5C14.5 13.6046 13.6046 14.5 12.5 14.5H3.5C2.39543 14.5 1.5 13.6046 1.5 12.5V3.5ZM11.3904 5.81235C11.5629 5.59672 11.528 5.28207 11.3123 5.10957C11.0967 4.93706 10.7821 4.97202 10.6096 5.18765L6.95854 9.75143L5.35355 8.14645C5.15829 7.95118 4.84171 7.95118 4.64645 8.14645C4.45118 8.34171 4.45118 8.65829 4.64645 8.85355L6.64645 10.8536C6.74701 10.9541 6.88565 11.0071 7.02765 10.9992C7.16965 10.9914 7.30159 10.9234 7.39043 10.8123L11.3904 5.81235Z"
        fill={color}
      />
    </svg>
  )
})

export default Annotate
